<template>
  <span class="gc-translation-cost-hint">
    <template v-if="prefix">{{ prefix }} </template>
    <span class="gc-translation-cost-hint__rate">{{ rateLabel }}</span>
    <span class="gc-translation-cost-hint__sep">·</span>
    <span class="gc-translation-cost-hint__label">Est.</span>
    <span class="gc-translation-cost-hint__amount">{{ amount }}</span>
    <span v-if="detail" class="gc-translation-cost-hint__detail">· {{ detail }}</span>
  </span>
</template>

<script>
import {
  formatEstimateUsd,
  formatTranslationCostDetail,
  getTranslationRateLabel
} from '@/plugins/translation-cost';

export default {
  name: 'TranslationCostHint',

  props: {
    estimate: {
      type: Object,
      required: true
    },
    targetLocaleCount: {
      type: Number,
      default: 1
    },
    prefix: {
      type: String,
      default: ''
    }
  },

  computed: {
    rateLabel() {
      return getTranslationRateLabel(this.estimate);
    },
    amount() {
      return formatEstimateUsd(this.estimate?.estimatedUsd);
    },
    detail() {
      return formatTranslationCostDetail(this.estimate, this.targetLocaleCount);
    }
  }
};
</script>
